import { EnvironmentVariableUtilities } from '@pwc/pwc-deals-web-common';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { getLoggedInUser } from '../../../../common/redux/security/loggedInUser/loggedInUserSelector';
import './WelcomeBox.scss';

const WelcomeBox = ({ children, isDisabled, isReturnUser }) => {
  const loggedInUser = useSelector(getLoggedInUser);

  const givenName =
    loggedInUser !== null ? loggedInUser.givenName : 'Nameless Person';

  const welcomeText = isReturnUser
    ? 'Welcome back, '
    : `Welcome to ${EnvironmentVariableUtilities.platformName}, `;

  return (
    <div
      className={classnames(
        'welcomebox-container',
        isDisabled && 'welcomebox-container__disabled'
      )}
    >
      <h2>
        <span>{welcomeText}</span>
        <span>{givenName}</span>
      </h2>
      {children}
    </div>
  );
};
export default WelcomeBox;
